export const enum EVoyageMessage {
  Cursor = 10,
  CrewSelected = 11,
  CrewMove = 12,
  CrewCreate = 13,
  CrewHurt = 14,
  BulletCreate = 15,
  CrewCarry = 16,
  CrewHurtEnergy = 17,
  Jettison = 18,
  CrewStyle = 19,
  HostCommand = 100,
  EffectCommand = 101,
  ShipStatus = 102,
  EnemyShipCommand = 103,
  GeneralCommand = 104,
  InfoRequest = 105,
  InfoSend = 106,
  WeaponCommand = 107,
  SystemCreate = 108,
  BuyRequest = 109,
  Jump = 110,
  Money = 111,
}
